export const categories = [
    {
      title: "Men",
      img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=1000",
      description: "Modern tailoring, relaxed essentials, and premium occasion wear.",
      sizes: ["XS", "S", "M", "L", "XL", "XXL"],
      types: ["Shirts", "T-Shirts", "Blazers", "Trousers", "Ethnic Wear", "Jackets"],
      customization: [
        "Custom sleeve length",
        "Neck and collar styles",
        "Monogram embroidery",
        "Fabric selection",
        "Altered fit: slim, regular, relaxed",
      ],
      SIZE_GUIDE_TOPS: [
        { label: "S", chest: '36"', shoulder: '16.5"', sleeve: '24.5"' },
        { label: "M", chest: '38"', shoulder: '17"', sleeve: '25"' },
        { label: "L", chest: '40"', shoulder: '17.5"', sleeve: '25.5"' },
        { label: "XL", chest: '42"', shoulder: '18"', sleeve: '26"' },
        { label: "XXL", chest: '44"', shoulder: '18.5"', sleeve: '26.5"' },
        { label: "3XL", chest: '46"', shoulder: '19"', sleeve: '27"' },
      ],
      SIZE_GUIDE_BOTTOMS: [
        { label: "28", waist: '28"', hip: '36"', inseam: '30"' },
        { label: "30", waist: '30"', hip: '38"', inseam: '30"' },
        { label: "32", waist: '32"', hip: '40"', inseam: '31"' },
        { label: "34", waist: '34"', hip: '42"', inseam: '31"' },
        { label: "36", waist: '36"', hip: '44"', inseam: '32"' },
        { label: "38", waist: '38"', hip: '46"', inseam: '32"' },
      ],
    },
    {
      title: "Women",
      img: "https://images.unsplash.com/photo-1487412720507-e78376483561?q=80&w=1000",
      description: "Elegant silhouettes, festive styles, and versatile everyday fashion.",
      sizes: ["XS", "S", "M", "L", "XL"],
      types: ["Dresses", "Tops", "Sarees", "Kurtas", "Co-ord Sets", "Outerwear"],
      customization: [
        "Custom blouse fitting",
        "Length adjustments",
        "Embroidery options",
        "Color customization",
        "Waist and bust fitting",
      ],
      SIZE_GUIDE_TOPS: [
        { label: "XS", bust: '32"', shoulder: '14"', sleeve: '22"' },
        { label: "S", bust: '34"', shoulder: '14.5"', sleeve: '22.5"' },
        { label: "M", bust: '36"', shoulder: '15"', sleeve: '23"' },
        { label: "L", bust: '38"', shoulder: '15.5"', sleeve: '23.5"' },
        { label: "XL", bust: '40"', shoulder: '16"', sleeve: '24"' },
      ],
      SIZE_GUIDE_BOTTOMS: [
        { label: "XS", waist: '24"', hip: '34"', inseam: '27"' },
        { label: "S", waist: '26"', hip: '36"', inseam: '27.5"' },
        { label: "M", waist: '28"', hip: '38"', inseam: '28"' },
        { label: "L", waist: '30"', hip: '40"', inseam: '28.5"' },
        { label: "XL", waist: '32"', hip: '42"', inseam: '29"' },
      ],
    },
    {
      title: "Kids",
      img: "https://images.unsplash.com/photo-1503919545889-aefd36e01c19?q=80&w=1000",
      description: "Comfort-first outfits, festive sets, and playful daily essentials.",
      sizes: ["2Y", "4Y", "6Y", "8Y", "10Y", "12Y"],
      types: ["Party Wear", "Casual Sets", "Traditional Wear", "T-Shirts", "Frocks", "Nightwear"],
      customization: [
        "Soft fabric choices",
        "Name embroidery",
        "Matching sibling sets",
        "Adjustable waist options",
        "Festival outfit customization",
      ],
      SIZE_GUIDE_TOPS: [
        { label: "2Y", chest: '20"', shoulder: '10"', sleeve: '12"' },
        { label: "4Y", chest: '22"', shoulder: '11"', sleeve: '14"' },
        { label: "6Y", chest: '24"', shoulder: '11.5"', sleeve: '16"' },
        { label: "8Y", chest: '26"', shoulder: '12"', sleeve: '17"' },
        { label: "10Y", chest: '28"', shoulder: '12.5"', sleeve: '18"' },
        { label: "12Y", chest: '30"', shoulder: '13"', sleeve: '19"' },
      ],
      SIZE_GUIDE_BOTTOMS: [
        { label: "2Y", waist: '20"', hip: '22"', inseam: '16"' },
        { label: "4Y", waist: '21"', hip: '23"', inseam: '18"' },
        { label: "6Y", waist: '22"', hip: '24"', inseam: '20"' },
        { label: "8Y", waist: '23"', hip: '25"', inseam: '22"' },
        { label: "10Y", waist: '24"', hip: '26"', inseam: '24"' },
        { label: "12Y", waist: '25"', hip: '27"', inseam: '26"' },
      ],
    },
  ];
